eyebrow: "Why Banoffee"
headline: "We don't parachute in<br/><em>generic AI.</em>"
lead: "Most agencies bring the same tools to every engagement. We bring domain practitioners to the table first — then build the AI around what they know."

cards:
  - icon: "🔬"
    iconClass: "di1"
    title: "Domain-First Engineering"
    body: "Every engagement begins with a practising domain expert — a legal professional, HR lead, or security practitioner — who validates the problem before we design the solution."
  - icon: "🤝"
    iconClass: "di2"
    title: "Expert Network Advantage"
    body: "Our collaborators surface real operational pain, not briefs. That's the difference between a tool your team actually uses and one that gets abandoned after onboarding."
  - icon: "🏗️"
    iconClass: "di3"
    title: "Narrow, Deep, Defensible"
    body: "We build for specificity. A system that handles True Copy stamping for Indian law firms is fundamentally different from a generic document tool — and far more valuable to the right buyer."
